import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getPageRouter } from './../../worker/utils/getPageRouter'
import type { DynamicPageType } from '@wix/wix-data-client-common'
import {
  getPageTypeFromPattern,
  getPatternDefForPage,
} from '@wix/wix-data-client-common'

export const getDynamicPageType = async ({
  editorSdkProxy,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
}): Promise<DynamicPageType | null> => {
  const router = await getPageRouter({
    editorSdkProxy,
    pageRef,
  })

  if (!router) {
    return null
  }

  const patternDefinition = getPatternDefForPage(
    router.config,
    router.pages,
    pageRef,
  )

  if (!patternDefinition) {
    return null
  }

  return getPageTypeFromPattern(patternDefinition.pattern)
}
